import { lazy } from 'react';

export const MedOrgDetailsPage = lazy(() => import('./MedOrgDetailsPage'));
